export default __webpack_public_path__ + "static/media/icon-people.e4fe1180.svg";